




















import { DateTime } from "luxon";
import { formatDate } from "@/utils/luxon";
import { computed } from "@vue/composition-api";
import { useNow } from "@vueuse/core";

export default {
    components: {},
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    setup(props) {
        const { now } = useNow({ controls: true });
        const getFormattedDate = (date) =>
            formatDate(date, DateTime.DATE_FULL) + " " + formatDate(date, DateTime.TIME_SIMPLE);
        const dateIsPast = computed(() => {
            return DateTime.fromISO(props.data.item.sendAt) < DateTime.fromJSDate(now.value);
        });
        return {
            getFormattedDate,
            dateIsPast,
        };
    },
};
